import { css } from 'styled-components';
import { renderStyle } from 'web-app/styleguide/render-style';
const GlobalCSS = renderStyle(css `
    * {
        margin: 0;
        padding: 0;
    }
    /* Prevents native pull to refresh in iOS browsers */
    html,
    body {
        position: fixed;
        overflow: hidden;
    }
    body > #root {
        width: 100vw;
        /*
         * On mobile web, 100vh resolves to the *largest* viewport (browser
         * address bar collapsed), so on initial load the root overflows below
         * the visible area and the bottom nav bar is pushed off-screen until
         * the user scrolls. 100dvh tracks the *current* visible viewport, so
         * the nav bar stays visible. 100vh is kept as a fallback for browsers
         * without dynamic viewport unit support.
         */
        height: 100vh;
        height: 100dvh;
        overflow-y: auto;
        overscroll-behavior: none; /* Prevents overscroll/bouncy scroll on iOS */
    }

    body {
        -webkit-touch-callout: none;
        -webkit-text-size-adjust: none;

        -webkit-text-size-adjust: 100%; /* 2 */

        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -moz-tap-highlight-color: rgba(0, 0, 0, 0);

        font-family: 'Matter', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        margin: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    button {
        outline: none;
    }
`);
export default GlobalCSS;
